// extracted by mini-css-extract-plugin
export default {"labelWrapper":"RulesList_labelWrapper--hbZ","rulesListItem":"RulesList_rulesListItem--eu8"};